export default __webpack_public_path__ + "static/media/logo19.1d36b505.svg";